/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2022-06-30 13:47:12
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderList/config.tsx
 */
import { IFulfillmentStatus, IOrderStatus } from '@/src/types/common/order';
import React from 'react';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { maskPhone, maskEmail, maskFullName } from 'src/tools/mask';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
import StatusTag from '../../Components/StatusTag';
import css from './css.module.less';
import { get } from 'lodash';
import {
  i18nGet,
  replaceI18nVariables,
  handleOnGetStoreTimezoneUTC,
} from 'src/tools/tools';

export {
  breadcrumbData,
  columns,
  filterList,
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
  tabsConfig,
};

const tabsConfig = (
  i18n,
  countOfReadyToPack,
  countOfReadyToPick,
  countOfReadyToShip,
) => [
  //定义tabs列表
  { name: i18nGet(i18n, 'allOrders.orderlist.config_tabs_all'), key: '' },
  {
    name: `${i18nGet(
      i18n,
      'allOrders.orderlist.config_tabs_pick',
    )} (${countOfReadyToPick})`,
    key: IFulfillmentStatus.READY_TO_PICK,
  },
  {
    name: `${i18nGet(
      i18n,
      'allOrders.orderlist.config_tabs_pack',
    )} (${countOfReadyToPack})`,
    key: IFulfillmentStatus.READY_TO_PACK,
  },
  {
    name: `${i18nGet(
      i18n,
      'allOrders.orderlist.config_tabs_ship',
    )} (${countOfReadyToShip})`,
    key: IFulfillmentStatus.READY_TO_SHIP,
  },
  {
    name: i18nGet(i18n, 'allOrders.orderlist.config_tabs_Delivered'),
    key: IFulfillmentStatus.DELIVERED,
  },
  {
    name: i18nGet(i18n, 'allOrders.orderlist.config_tabs_Suspended'),
    key: IOrderStatus.SUSPENDED,
  },
  {
    name: i18nGet(i18n, 'allOrders.orderlist.config_tabs_Cancelled'),
    key: IOrderStatus.CANCELLED,
  },
];

const filterList = (salesChannelList, { i18n }) => [
  {
    type: EnumFilterType.MultipleSelection,

    dropdownProps: {
      name: i18nGet(i18n, 'allOrders.orderlist.config_filterList_SalesChannel'),
    },
    keyWord: 'salesChannelUuids',
    options: salesChannelList.map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: i18nGet(i18n, 'allOrders.orderlist.config_filterList_order'),
    },
    keyWord: 'orderStatuses',
    options: Object.values(IOrderStatus)
      .filter((i) => i !== IOrderStatus.COMPLETE)
      .map((item) => ({
        label: statusText[item],
        value: item,
      })),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: i18nGet(i18n, 'allOrders.orderlist.config_filterList_payment'),
    },
    keyWord: 'paymentStatuses',
    options: Object.entries(paymentStatusText).map((item) => ({
      label: item[1],
      value: item[0],
    })),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: i18nGet(i18n, 'allOrders.orderlist.config_filterList_fulfillement'),
    },
    keyWord: 'fulfillmentStatuses',
    options: Object.entries(fulfillmentStatusesText).map((item) => ({
      label: item[1],
      value: item[0],
    })),
  },
];

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.sider.orders'),
  },
  {
    url: '',
    name: getI18n('general.sider.allOrders'),
  },
];

const columns = (timezoneInGMT, reportingCurrency, { i18n }) => [
  {
    title: i18nGet(i18n, 'allOrders.orderlist.config_columns_orderid'),
    dataIndex: 'orderNo',
    key: 'orderNo',
    default: true,
    optional: false,
    sorter: true,
    className: css.columnClass,
    width: 104,
  },
  {
    title: replaceI18nVariables(
      i18nGet(i18n, 'allOrders.orderlist.config_columns_orderCreated'),
      timezoneInGMT,
    ), //`Order Created (UTC${timezoneInGMT})`,
    dataIndex: 'createdDate',
    default: true,
    optional: true,
    sorter: true,
    key: 'createdDate',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: `${i18nGet(
      i18n,
      'allOrders.orderlist.config_columns_PaymentTime',
    )} (UTC ${handleOnGetStoreTimezoneUTC()})`,
    dataIndex: 'paymentTime',
    default: false,
    optional: true,
    key: 'paymentTime',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: i18nGet(i18n, 'allOrders.orderlist.config_columns_Buyer'),
    dataIndex: 'buyerName',
    default: true,
    optional: true,
    key: 'buyerName',
    className: css.columnClass,
    minWidth: 152,
    childGenerate: (text, record) => {
      const { buyerFirstName, buyerLastName } = record;
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {maskFullName(buyerLastName, buyerFirstName, text)}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_buyer'semail`),
    dataIndex: 'buyerEmail',
    default: false,
    optional: true,
    key: 'buyerEmail',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{maskEmail(text)}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_buyer'sphone`),
    dataIndex: 'buyerPhoneNo',
    default: false,
    optional: true,
    key: 'buyerPhoneNo',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{maskPhone(text)}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_Recipient`),
    dataIndex: 'recipientName',
    default: false,
    optional: true,
    key: 'recipientName',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text, record) => {
      const { recipientFirstName, recipientLastName } = record;
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>
            {maskFullName(recipientLastName, recipientFirstName, text)}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_Recipient’sEmail`),
    dataIndex: 'recipientEmail',
    default: false,
    optional: true,
    key: 'recipientEmail',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{maskEmail(text)}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_Recipient’sPhone`),
    dataIndex: 'recipientPhoneNo',
    default: false,
    optional: true,
    key: 'recipientPhoneNo',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text) => {
      return (
        <NoWrapContainer>
          <GlobalTooltip title={text}>{maskPhone(text)}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(i18n, `general.currency`),
    dataIndex: 'currencyCode',
    default: true,
    optional: true,
    sorter: true,
    key: 'currencyCode',
    className: css.columnClass,
    minWidth: 100,
    childGenerate: (text) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_TotalPaid`),
    dataIndex: 'totalPrice',
    default: true,
    optional: true,
    key: 'totalPrice',
    sorter: true,
    className: css.columnClass,
    minWidth: 115,
    childGenerate: (text, record) => {
      const currency = get(record, 'currencyCode');
      return (
        <NoWrapContainer>
          <GlobalTooltip title={currency + ' ' + text}>
            {currency + ' ' + text}
          </GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: i18nGet(
      i18n,
      `allOrders.orderlist.config_columns_totalPaidCurrency`,
    ),
    dataIndex: 'reportingTotalPrice',
    default: true,
    optional: true,
    sorter: true,
    key: 'reportingTotalPrice',
    className: css.columnClass,
    minWidth: 170,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={reportingCurrency + ' ' + text}>
          {reportingCurrency + ' ' + text}
        </GlobalTooltip>
      </NoWrapContainer>
    ),
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_filterList_SalesChannel`),
    dataIndex: 'salesChannelName',
    default: true,
    optional: true,
    key: 'salesChannelName',
    className: css.columnClass,
    minWidth: 123,
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_warehouse`),
    dataIndex: 'warehouseName',
    default: true,
    optional: true,
    key: 'warehouseName',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_filterList_order`),
    dataIndex: 'orderStatus',
    key: 'orderStatus',
    default: true,
    optional: true,
    align: 'center',
    className: css.columnClass,
    minWidth: 118,
    childGenerate: (text, _, index) => {
      return <StatusTag status={text} calculate={statusText} />;
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_filterList_payment`),
    dataIndex: 'paymentStatus',
    default: true,
    optional: true,
    className: css.columnClass,
    key: 'paymentStatus',
    width: 150,
    childGenerate: (text, _, index) => {
      return <StatusTag status={text} calculate={paymentStatusText} />;
    },
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_filterList_fulfillement`),
    dataIndex: 'fulfillmentStatus',
    default: true,
    optional: true,
    className: css.columnClass,
    childGenerate: (text, _, index) => {
      return <StatusTag status={text} calculate={fulfillmentStatusesText} />;
    },
    key: 'fulfillmentStatus',
    width: 150,
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_SalesRepresent`),
    dataIndex: 'salesRepresent',
    default: false,
    optional: true,
    key: 'salesRepresent',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: i18nGet(i18n, `allOrders.orderlist.config_columns_Remark`),
    dataIndex: 'userRemark',
    default: false,
    optional: true,
    key: 'userRemark',
    className: css.columnClass,
    minWidth: 128,
  },
];
